import { closest } from 'js/tools';

const CLASS_NODE = 'multi-select';
const CLASS_INPUT_CHECKBOX_COMPONENT = 'input-checkbox';
const CLASS_HAS_SELECTION = 'multi-select--has-selection';
const CLASS_OPENED = 'multi-select--opened';

const SELECTOR_CHECKBOX_GROUP = '.checkbox-group';
const SELECTOR_INPUT_CHECKBOX_COMPONENT = '.input-checkbox';
const SELECTOR_SELECTION = '.multi-select__selection';
const SELECTOR_VALUES = '.multi-select__values';

export default node => {
    const checkboxGroup = node.querySelector(SELECTOR_CHECKBOX_GROUP);
    const inputCheckboxComponents = node.querySelectorAll(SELECTOR_INPUT_CHECKBOX_COMPONENT);
    const selectionNode = node.querySelector(SELECTOR_SELECTION);
    const valuesNode = node.querySelector(SELECTOR_VALUES);

    selectionNode.addEventListener('click', toggle);

    inputCheckboxComponents.forEach(inputCheckboxComponent => {
        inputCheckboxComponent.jsApi.subscribe('change', () => update());
    });

    document.addEventListener('click', e => handleClick(e));

    function handleClick(e) {
        const componentNode = closest(e.target, CLASS_NODE);

        if (componentNode && componentNode === node) {
            return;
        }

        close();
    }

    function update() {
        const selectedValues = getSelectedValues();

        setValuesText(selectedValues.join(', '));

        if (selectedValues.length) {
            node.classList.add(CLASS_HAS_SELECTION);
        } else {
            node.classList.remove(CLASS_HAS_SELECTION);
        }
    }

    function updateByState(options) {
        const fieldName = getFieldName();

        options.forEach(({ count, name, selected }) => {
            const inputCheckboxNode = node.querySelector(`#${fieldName}_${name}`);
            const inputCheckboxComponent = closest(inputCheckboxNode, CLASS_INPUT_CHECKBOX_COMPONENT);

            inputCheckboxComponent.jsApi.toggle(selected);

            if (typeof count !== 'undefined') {
                inputCheckboxComponent.jsApi.setCount(count);

                if (count === 0 && !selected) {
                    inputCheckboxComponent.jsApi.disable();
                } else {
                    inputCheckboxComponent.jsApi.enable();
                }
            }
        });
    }

    function toggle() {
        isOpened() ? close() : open();
    }

    function isOpened() {
        return node.classList.contains(CLASS_OPENED);
    }

    function open() {
        node.classList.add(CLASS_OPENED);
    }

    function close() {
        node.classList.remove(CLASS_OPENED);
    }

    function setValuesText(text) {
        valuesNode.innerHTML = text;

        selectionNode.setAttribute('title', text);
    }

    function getFieldName() {
        return checkboxGroup.getAttribute('data-group-name');
    }

    function getSelectedValues() {
        const selectedValues = [];

        inputCheckboxComponents.forEach(inputCheckboxComponent => {
            if (inputCheckboxComponent.jsApi.isChecked()) {
                selectedValues.push(inputCheckboxComponent.jsApi.getLabel());
            }
        });

        return selectedValues;
    }

    return {
        updateByState
    };
};
